import { render, staticRenderFns } from "./PartnerCardCreateUpdate.vue?vue&type=template&id=8b8aea9a&scoped=true"
import script from "./PartnerCardCreateUpdate.vue?vue&type=script&lang=js"
export * from "./PartnerCardCreateUpdate.vue?vue&type=script&lang=js"
import style0 from "./PartnerCardCreateUpdate.vue?vue&type=style&index=0&id=8b8aea9a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b8aea9a",
  null
  
)

export default component.exports